import $ from 'jquery'
import Base from 'luminate/src/modules/base'
import {frame, dependency} from '../utilities'
import Init from '../init'

const swiperDir = 'https://cdnjs.cloudflare.com/ajax/libs/Swiper/3.3.1/'
let addedCss = false

export default Base.extend({
	directive: 'swiper',

	defaults: {
		loop: true,
		preloadImages: false,
		lazyLoading: true,
		lazyLoadingInPrevNext: true,
		paginationElement: 'button',
		paginationClickable: true,
		runCallbacksOnInit: true
	},

	events: {

		init: function()
		{
			if(!addedCss)
			{
				$('head').append(`<link rel="stylesheet" href="${swiperDir}css/swiper.min.css">`)
				addedCss = true
			}

			dependency(swiperDir + 'js/swiper.min.js', () =>
			{
				const $element = $(this.$element)
				const swiper = new Swiper(this.$element, this.$settings)

				if($element.hasClass('slideshow') && $element.hasClass('-fit-image'))
				{
					const getHeight = () =>
					{
						let maxHeight = 0

						$element.find('.slideshow_slide_content').each(function()
						{
							const $this = $(this)
							const paddingTop = parseFloat($this.css('padding-top').replace('px', ''))
							const paddingBottom = parseFloat($this.css('padding-bottom').replace('px', ''))
							const innerHeight = $this.children().height()

							maxHeight = Math.max(maxHeight, innerHeight + paddingTop + paddingBottom)
						})

						return maxHeight
					}

					const setHeight = () =>
					{
						const minHeight = getHeight()

						$element.find('.slideshow_slide_background')
							.css('min-height', minHeight + 'px')

						$element.find('.slideshow_slide_background .media').each(function()
						{
							const $this = $(this)
							const height = $this.height()

							$this.css('transform', height < minHeight ? `scale(${minHeight / height})` : '')
						})
					}

					$(e => frame(setHeight))
					$(window).on('load resize', e => frame(setHeight))

					swiper.on('slideChangeStart', setHeight)
					swiper.on('slideChangeEnd', setHeight)

					setHeight()
				}

				swiper.on('slideChangeStart', e => $element.find('.swiper-slide-duplicate').each(function()
				{
					const $slide = $(this)

					if($slide.hasClass('swiper-slide-active') && !$slide.data('init'))
					{
						Init(this)
						$slide.data('init', true)
					}
				}))

				$element.addClass('swiper-ready')

			}, () => window.Swiper)
		}
	}
})



// WEBPACK FOOTER //
// ./source/scripts/modules/swiper.js